import React from 'react';
import camelCase from 'lodash/camelCase';
import { defineMessages } from '@atlassian/jira-intl';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';

const messages = defineMessages({
	componentLead: {
		id: 'project-components.table-default-assignee-cell-component-lead',
		defaultMessage: 'Component lead',
		description: '',
	},
	projectDefault: {
		id: 'project-components.table-default-assignee-cell-project-default',
		defaultMessage: 'Project default',
		description: '',
	},
	projectLead: {
		id: 'project-components.table-default-assignee-cell-project-lead',
		defaultMessage: 'Project lead',
		description: '',
	},
	unassigned: {
		id: 'project-components.table-default-assignee-cell-unassigned',
		defaultMessage: 'Unassigned',
		description: '',
	},
});

type Props = {
	intl: IntlShape;
	defaultAssignee?: string;
};

function DefaultAssigneeView(props: Props) {
	const {
		defaultAssignee,
		intl: { formatMessage },
	} = props;

	if (!defaultAssignee) {
		return null;
	}

	return (
		<span data-test-id="project-directories.components.table.cell.default-assignee">
			{/* @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ componentLead: { id: string; defaultMessage: string; description: string; }; projectDefault: { id: string; defaultMessage: string; description: string; }; projectLead: { id: string; defaultMessage: string; description: string; }; unassigned: { ...; }; }'. */}
			{formatMessage(messages[camelCase(defaultAssignee)])}
		</span>
	);
}

export default injectIntl(DefaultAssigneeView);
